module.exports = __webpack_public_path__ + "img/201.e0feeeff.jpg";